// extracted by mini-css-extract-plugin
export default {"userRealmTag":"RealmTag_userRealmTag"};